import { PdfViewerStylesHttpResponse } from 'app/types/pdfViewerStyles';
import axios from 'axios';

export const PDF_VIEWER_STYLES = 'v3/courses/{course_guid}/pdf-viewer-styles';

export function getPdfViewerStyles(courseGuid: string): Promise<PdfViewerStylesHttpResponse> {
  return axios.get(PDF_VIEWER_STYLES.replace('{course_guid}', courseGuid), { params: { is_enabled: true } });
}
